import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { AzureIntegrationView } from "../../../useSearchCloudIntegrations/gql";

const IntegrationsAzureTableSpaceCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AzureIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace href={`/spaces/${item.spaceDetails.id}`}>
        {item.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default IntegrationsAzureTableSpaceCell;
